export const APP_ROUTES = {
  chat: '/',
  instanceAdministration: '/instance-admin',
  profile: '/profile',
  settingsRoot: '/settings',
  settingsProfile: '/settings/profile',
  settingsSystem: '/settings/system',
} as const

export type SettingsSection = 'profile' | 'system'
